import { getCotizaCabs, createCotizaCab, updateCotizaCab, deleteCotizaCab } from '../models/cotizaCabModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchCotizaCabs(page, perPage) {
  try {
    const response = await getCotizaCabs(page, perPage);
    return {
      cotiza_cab: response.items,
      totalItems: response.totalItems,
      page: response.page,
    };
  } catch (error) {
    console.error("Error fetching cotiza_cab:", error);
    Swal.fire('Error', 'No se pudieron cargar las cotizaciones', 'error');
    return null;
  }
}

export async function saveCotizaCab(cotizaCab, currentCotizaCabId) {
  try {
    console.log('saveCotizaCab called with:', { cotizaCab, currentCotizaCabId });
    
    let result;
    if (currentCotizaCabId) {
      console.log('Updating existing cotiza_cab');
      result = await updateCotizaCab(currentCotizaCabId, cotizaCab);
      toasts.add({
        title: 'Éxito',
        description: 'Cotización guardada exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    } else {
      console.log('Creating new cotiza_cab');
      result = await createCotizaCab(cotizaCab);
      console.log('Created cotiza_cab result:', result);
      toasts.add({
        title: 'Éxito',
        description: 'Cotización creada exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true,
      });
    }
    return result;
  } catch (error) {
    console.error("Error saving cotiza_cab:", error);
    console.error("Error details:", error.data);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar la cotización',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
    throw error;
  }
}

export async function removeCotizaCab(id) {
  try {
    await deleteCotizaCab(id);
    toasts.add({
      title: 'Éxito',
      description: 'Cotización eliminada exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true,
    });
  } catch (error) {
    console.error("Error deleting cotiza_cab:", error);
    Swal.fire('Error', 'No se pudo eliminar la cotización', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'cotiza_cab'
export function subscribeToCotizaCabs(searchQuery, handleSearch) {
  pb.collection('cotiza_cab').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(); // Actualiza la lista manteniendo la página actual
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromCotizaCabs() {
  pb.collection('cotiza_cab').unsubscribe('*');
}

export async function searchCotizaCabs(query, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('cotiza_cab').getList(page, perPage, {
      filter: `numero ~ "${query}" || nombre ~ "${query}" || nit ~ "${query}"`,
      expand: 'cotiza_det'
    });
    return {
      cotiza_cab: response.items,
      totalItems: response.totalItems,
      page: response.page,
    };
  } catch (error) {
    console.error("Error searching cotiza_cab:", error);
    Swal.fire('Error', 'No se pudieron buscar las cotizaciones', 'error');
    return null;
  }
}

// Flag to prevent concurrent requests
let isGeneratingNumber = false;
let lastGenerationTime = 0;

// Generar número de cotización automático
export async function generateCotizaNumber() {
  const now = Date.now();
  
  // If already generating, return a fallback number
  if (isGeneratingNumber) {
    console.log('Number generation already in progress, using fallback');
    return generateFallbackNumber();
  }
  
  // If called too soon after last generation, use fallback
  if (now - lastGenerationTime < 1000) {
    console.log('Number generation called too soon, using fallback');
    return generateFallbackNumber();
  }
  
  isGeneratingNumber = true;
  lastGenerationTime = now;
  
  try {
    const response = await pb.collection('cotiza_cab').getList(1, 1, {
      sort: '-created',
      fields: 'numero',
      $autoCancel: false // Prevent auto-cancellation
    });
    
    if (response.items.length > 0 && response.items[0].numero) {
      const lastNumber = parseInt(response.items[0].numero) || 0;
      return (lastNumber + 1).toString().padStart(6, '0');
    } else {
      return '000001';
    }
  } catch (error) {
    console.error("Error generating cotiza number:", error);
    return generateFallbackNumber();
  } finally {
    isGeneratingNumber = false;
  }
}

// Generate a fallback number based on timestamp
function generateFallbackNumber() {
  const timestamp = Date.now();
  const lastDigits = timestamp.toString().slice(-6);
  return lastDigits.padStart(6, '0');
}
